export default class datatableSortIconController {
  isCurrentSortOrder() {
    return this.selectedSortKey === this.key;
  }
}
